import {Component, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-template',
  templateUrl: './select-template.component.html',
  styleUrl: './select-template.component.scss',
  encapsulation: ViewEncapsulation.Emulated
})
export class SelectTemplateComponent{
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

}
